export default {
  mensajes: {
    inicial: 'Hallo!',
    descripcion: 'In nur drei  Schritten,erhälst Du hier schnell und einfach Dein Angebot.',
    resumen: 'Angebot ansehen',
  
    datos_de_reserva: 'Buchungsdaten',
    datos_personales: 'Persönliche Daten',
    resumen_reserva: 'Angebot gesendet!',
  
    preguntaPaso1: 'Wir benötigen einige Eckdaten um das Angebot Deines Jakobswegs für Dich zu erstellen:  Ankunftsdatum, Anzahl der Pilger/innen, Anzahl der Zimmer und Zimmertyp',
    datos_reserva: {
      fechas_seleccion: 'Startdatum(Anreisetag)',

      habitaciones_individuales: 'Einzelzimmer',
      habitaciones_dobles: 'Doppelzimmer (2_Einzelbetten)',
      habitaciones_dobles_matrimoniales: 'Doppelzimmer (1_Doppelbett)',
      habitaciones_triples: 'Dreibettzimmer',
      cantidad_de_peregrinos: 'Anzahl der Pilger/innen',

      titulo: 'Buchungsdaten:',
      fecha_inicio: 'Ankunftsdatum:',
      fecha_llegada: 'Abreisedatum:',
      habitaciones: 'Zimmer:',
      peregrinos: 'Pilger/innen:',
      comentarios: 'Erzähle uns jede zusätzliche Information.\nHaben Kinder? Sag uns ihre Alter.\nHaben Tiere? Sag uns, welches Tier es ist und sein Gewicht.',

      importe_reserva: 'Grundbetrag:',
      servicios_agregados: 'Zusatzleistungen:',
      importe_total: 'Gesamtbetrag:',
      comision_agencia: '15% Provision:',
      importe_neto_agencia: 'Netto Provision:',
      no_comisionable: '(Nicht kommissionierbar)',
      precio_por_peregrino: '€/Pilger',
    },

    servicios: {
      tab_servicios: 'Leistungen',
      incluidos_titulo: 'Enthaltene Leistungen:',
      incluidos_subtitulo: 'Wenn Du eine der enthaltenen Leistungen stornieren möchtest, kannst Du sie entfernen.',
      opcionales_titulo: 'Optionale Zusatzleistungen:',
      pendiente_de_tarifa: 'Ausstehend',
      subtitulo_desde: '(Von {tarifa}€)',
      subtitulo_por_persona: '({tarifa}€ x Pilger/innen)',
      subtitulo_por_persona_con_persona: '({tarifa}€ x {personas} Pilger/innen)',
      noche_extra_en: 'Zusatznacht in',
      traslado_extra: 'Zusatztransfer',
      servicio_extra: 'Zusatzleistung',
      ver_incluidos_boton: 'Inklusive Leistungen anzeigen',
    },

    siguientePaso1: 'Weiter',

    preguntaPaso2: 'Nun benötigen wir Deine Daten um Dir das Angebot so schnell wie möglich zu senden.',
    nombre: 'Vorname',
    apellidos: 'Nachname',
    telefono: 'Telefonnummer',
    email: 'E-Mail Adresse',

    politica_privacidad: 'Ich akzeptiere die ',
    politica_privacidad_texto_enlace: 'Datenschutzerklärung',
    politica_privacidad_enlace: 'https://rutasmeigas.com/de/datenschutz',

    acepta_novedades: 'Ich bin damit einverstanden, aktuelle Nachrichten zu erhalten.',

    recibir_presupuesto: 'Angebot anfordern',
    enviando_presupuesto: 'Angebot wird gesendet...',
    presupuesto_enviado: 'ANGEBOT GESDENDET!',

   
    datos_pasajeros: {
      titulo: "In Übereinstimmung mit der geltenden spanischen Gesetzgebung (Königliches Dekret 933/2021 vom 26. Oktober), das die Pflichten zur dokumentarischen Registrierung und Information von natürlichen oder juristischen Personen festlegt, die Beherbergungstätigkeiten ausüben (Reisebüros, Hotelbetriebe und Autovermietungen von Fahrzeugen). muss dem Innenministerium (Spanien) die folgenden Daten übermitteln.",
      subtitulo: 'Um Deine Buchung zu bearbeiten benötigen wir die kompletten Daten aller Pilger welche den Jakobsweg gehen. Bitte gib hier die Daten jedes einzelnen Pilgers im entsprechenden Formular an.<br>Es ist wichtig, dass die Daten so genau  und komplett wie möglich sind da wir diese nutzen um die Reise zu organisieren, Unterkünfte und andere Serviceleistungen zu reservieren.<br>Sobald alles komplett ausgefüllt ist, werden wir Deine Buchung bestätigen. Wenn Du Fragen hast oder etwas unklar ist , setze Dich bitte mit uns in Verbindung.',
      datos_peregrino: 'Reisender {index}',
      confirmar_datos: 'Daten bestätigen',
      guardar_datos: 'Daten der Reisenden speichern',


      nombre: 'Vorname',
      primer_apellido: 'Nachname',
      segundo_apellido: 'Zweiter Nachname',
      sexo: 'Geschlecht',
      sexo_opciones: {
        hombre: 'Männlich',
        mujer: 'Weiblich',
        no_decir: 'Keine Angabe',
      },
      fecha_nacimiento: 'Geburtsdatum',
      tipo_documento: 'Dokumenttyp',
      tipo_documento_opciones: {
        dni: 'DNI',
        nie: 'NIE',
        pasaporte: 'Reisepass',
      },
      numero_documento: 'Dokumentnummer',
      soporte_documento: 'Dokumentunterlage',
      telefono_fijo: 'Festnetztelefon',
      telefono_movil: 'Mobiltelefon',
      email: 'E-Mail Adresse',
      direccion: 'Adresse',
      poblacion: 'Ort',
      provincia: 'Provinz',
      codigo_postal: 'Postleitzahl',
      nacionalidad: 'Nationalität',
      parentesco: 'Beziehung',


      mensaje_final_success: 'Vielen Dank. Die Daten der Reisenden wurden erfolgreich gespeichert.',
      pagar: 'Bezahlen',
      mensaje_confirmacion_pasajero_y_pago: 'Deine Daten wurden erfolgreich gesendet. Wir informieren Dich, dass der Gesamtbetrag der Buchung {importe} € beträgt.<br>Du kannst jetzt einen Vorauszahlungsbetrag von 100 € für die Buchung leisten.',
      pago_realizado: 'Zahlung erfolgreich',
      pago_realizado_subtitulo: 'Vielen Dank für Ihre Vertrauen.<br>Wir werden uns schnellstmöglich um die Details Ihrer Buchung kümmern.',
      politica_privacidad: `Verantwortlicher für die Verarbeitung: RUTAS MEIGAS SL CIF: B15649270 Postanschrift: LUGAR DO BARCO 1, 15917 - PADRON (A CORUÑA) Telefon: 881019941 E-Mail: info@rutasmeigas.com
      Zweck der Verarbeitung Ihrer Daten: In Übereinstimmung mit den Bestimmungen der geltenden Gesetzgebung zum Schutz personenbezogener Daten, der Datenschutz-Grundverordnung 2016/679 (DSGVO) und des Organgesetzes 3/2018 vom 5. Dezember zum Schutz personenbezogener Daten und zur Gewährleistung digitaler Rechte (LOPDGDD) informieren wir Sie, dass der Zweck der Verarbeitung Ihrer Daten die Durchführung der Verwaltung Ihrer Reservierung ist.
      Legitimation: Artikel 6.1.a) der DSGVO. Die betroffene Person hat der Verarbeitung ihrer personenbezogenen Daten für einen oder mehrere bestimmte Zwecke zugestimmt. Artikel 6.1.b) der DSGVO. Verarbeitung, die für die Erfüllung eines Vertrags erforderlich ist, dessen Vertragspartei die betroffene Person ist, oder für die Durchführung vorvertraglicher Maßnahmen auf Anfrage der betroffenen Person. Artikel 6.1.c) der DSGVO: Die Verarbeitung ist für die Erfüllung einer gesetzlichen Verpflichtung erforderlich, der der Verantwortliche unterliegt: Königliches Dekret 933/2021 vom 26. Oktober zur Festlegung der Dokumentations- und Informationspflichten natürlicher oder juristischer Personen, die Beherbergungs- und Kraftfahrzeugvermietungstätigkeiten durchführen. Artikel 45 des Schengener Abkommens vom Juni 1985 • Organgesetz 4/2015 vom 30. März 2015 zum Schutz der Sicherheit der Bürger
      Aufbewahrung und Behandlung von Daten: Die bereitgestellten Daten werden so lange aufbewahrt, bis Sie ihre Löschung nicht beantragen, oder für die Zeit, die erforderlich ist, um gesetzlichen Verpflichtungen nachzukommen und möglichen Verbindlichkeiten nachzukommen, die sich aus der Erfüllung des Zwecks ergeben können, für den die Daten erhoben wurden. Ihre Daten werden an die verschiedenen Großhandelsunternehmen, mit denen das Unternehmen zusammenarbeitet, sowie gegebenenfalls an Fluggesellschaften, Hotels, Autovermietungen und/oder Reiseveranstalter übermittelt, um deren Dienstleistungen zu beauftragen oder Informationen zu Verfügbarkeit und Preisen anzufordern. Diese Anbieter können sich, je nach Land Ihres Reiseziels, in Ländern befinden, die kein vergleichbares Datenschutzniveau wie das in der EU haben, für die die Übermittlung zur Durchführung vertraglicher Maßnahmen erforderlich ist. Sie können auch an andere Unternehmen übermittelt werden, mit denen RUTAS MEIGAS SL zusammenarbeitet/kollaboriert, um die entsprechenden Verfahren und/oder Dienstleistungen durchzuführen. Andere Daten werden nicht an Dritte übermittelt, außer in Fällen, in denen eine gesetzliche Verpflichtung besteht. RUTAS MEIGAS SL erstellt auf der Grundlage der bereitgestellten Informationen keinerlei „Profile". Es werden keine automatisierten Entscheidungen auf der Grundlage von Profilen getroffen.
      Rechte: Sie können Ihre Rechte auf Zugriff, Berichtigung, Löschung, Widerspruch, Einschränkung der Verarbeitung, Datenübertragbarkeit und das Recht, keinen automatisierten Einzelentscheidungen in Bezug auf die verarbeiteten Daten zu unterliegen, gegenüber dem Verantwortlichen unter der Adresse RÚA LISBOA 16 BAJO IZDA – 15707 – SANTIAGO DE COMPOSTELA oder per E-Mail an info@rutasmeigas.com ausüben und eine Kopie Ihres Personalausweises oder eines gleichwertigen Dokuments beifügen. Falls Sie bei der Ausübung Ihrer Rechte nicht zufrieden sind, können Sie eine Beschwerde bei der zuständigen Datenschutzbehörde einreichen, der spanischen Datenschutzbehörde, deren Kontaktdaten unter https://sedeagpd.gob.es/sede-electronica-web/vistas/formNuevaReclamacion/reclamacion.jsf verfügbar sind.`
    },

    ir_al_camino: 'Mehr Informationen zum Jakobsweg',

    enviar_consulta: 'Senden',
    texto_consulta_agencia: 'Senden Sie Ihre Anfrage und wir werden uns schnellstmöglich um Ihre Anfrage kümmern.',
    consulta_enviada: 'Wir haben Ihre Anfrage erhalten, wir werden uns schnellstmöglich um Ihre Anfrage kümmern. Vielen Dank!',
 

  
  },
 
}
